<template>
  <div>
    <common-list
      ref="list"
      url="RecoveryCar/GetList"
      :init="filter"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input
              v-model="filter.LicensePlate"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="VIN后六位">
            <el-input
              v-model="filter.VinSix"
              placeholder="VIN后六位"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车主姓名">
            <el-input
              v-model="filter.OwnerName"
              placeholder="车主姓名"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否代办">
            <el-select v-model="filter.IsProve" clearable>
              <el-option value="1" label="是"></el-option>
              <el-option value="0" label="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收车人">
            <RemoteSelect
              v-model="filter.CreateUserId"
              url="User/GetOrgUserList"
              code="UId"
              name="Username"
            ></RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收车日期">
            <DateRangePicker v-model="filter.selectedDate"></DateRangePicker>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:option>
        <el-button type="warning" icon="el-icon-edit" @click="show"
          >查看</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="exp"
          >导出</el-button
        >
      </template>

      <template v-slot:body>
        <el-table-column
          label="车辆编号"
          prop="KeyId"
          width="240"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="车牌号" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.LicensePlate | gang
          }}</template></el-table-column
        >

        <el-table-column label="VIN后六位" prop="VinSix" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.VinSix | gang }}</template>
        </el-table-column>
        <el-table-column
          label="车主姓名"
          prop="OwnerName"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          label="联系电话"
          prop="ContactNumber"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column label="是否代办" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.IsProve | enumer("yes_no_state") }}
          </template></el-table-column
        >
        <el-table-column label="代办人" prop="ClientUser" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.ClientUser | gang
          }}</template>
        </el-table-column>
        <el-table-column
          label="收车人"
          prop="CreateUserId"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{
            scope.row.CreateUserId | UserNameInfo
          }}</template>
        </el-table-column>

        <el-table-column label="收车时间" show-overflow-tooltip width="240"
          ><template slot-scope="{ row }">
            {{ row.CreateTime | gang }}
          </template></el-table-column
        >
      </template>
    </common-list>
    <div><Showdialog :item="itemShow"></Showdialog></div>
  </div>
</template>

<script>
import Showdialog from "./Show";
export default {
  components: { Showdialog },
  computed: {},
  data() {
    return {
      filter: {},
      itemShow: {},
    };
  },
  watch: {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemShow = { KeyId: this.currentrow.KeyId };
    },
    //导出excel
    exp() {
      if (!this.hasCurrentRow()) {
        this.$message.error("导出信息为空，请核对查询条件！");
        return;
      }

      this.$download("RecoveryCar/RecoveryCarExport", {
        ...this.$refs.list.filter,
        FileName: "收车记录",
      });
    },
  },
};
</script>

<style></style>